import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import firebase from "firebase";
import Login from "../views/Login.vue";
// import Recipes from "../views/Recipes.vue";
import ShoppingList from "../components/ShoppingList.vue";
import ListItem from "../components/ListItem.vue";
import Invites from "../components/Invites.vue";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes: [
    {
      path: "*",
      redirect: "/home"
    },
    {
      path: "/home",
      name: "home",
      component: Home,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/list/:user_list_id/:id",
      name: "list",
      component: ShoppingList,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/listItem/:list_id/:id",
      name: "list-item",
      component: ListItem,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/invites",
      name: "invites",
      component: Invites,
      meta: {
        requiresAuth: true
      }
    },
    // {
    //   path: "/products",
    //   name: "products",
    //   component: Products,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    // {
    //   path: "/recipes",
    //   name: "recipes",
    //   component: Recipes,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "../views/About.vue")
    }
  ]
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth);
  const currentUser = firebase.auth().currentUser;

  if (requiresAuth && !currentUser) {
    next("/login");
  } else if (requiresAuth && currentUser) {
    next();
  } else {
    next();
  }
});

export default router;
